/**
 * Extract detailed error message from API error response
 * Handles various error formats from Django REST Framework
 */
export function extractErrorMessage(error: any): string {
  if (!error) return 'An unknown error occurred'

  // Check for axios error response
  if (error.response?.data) {
    const data = error.response.data

    // Django validation errors with field-specific messages
    if (data.validation_errors) {
      const errors = Array.isArray(data.validation_errors)
        ? data.validation_errors.join('\n')
        : JSON.stringify(data.validation_errors, null, 2)
      return `Validation failed:\n${errors}`
    }

    // Main error message field
    if (data.error) {
      return data.error
    }

    // DRF detail field
    if (data.detail) {
      return data.detail
    }

    // Generic message field
    if (data.message) {
      return data.message
    }

    // Field-specific errors (common in DRF)
    const fieldErrors = Object.entries(data)
      .filter(([key]) => !['warnings', 'details'].includes(key))
      .map(([field, errors]) => {
        const errorList = Array.isArray(errors) ? errors.join(', ') : errors
        return `${field}: ${errorList}`
      })
      .filter(msg => !msg.includes('[object Object]'))

    if (fieldErrors.length > 0) {
      return fieldErrors.join('\n')
    }
  }

  // Check for error message directly on error object
  if (error.message) {
    return error.message
  }

  // Fallback to status text if available
  if (error.response?.statusText) {
    return `Request failed: ${error.response.statusText}`
  }

  return 'An unexpected error occurred'
}
